<div class="gallery-container">
  <swiper-container class="gallery-swiper" [slidesPerView]="isSmallScreen$() ? 1 : 3" [spaceBetween]="20" [centeredSlides]="true"
    [pagination]="{ clickable: true }" initial-slide="1" [loop]="thumbnailImages().length > 3">
    @for (image of thumbnailImages(); track $index) {
        @let url = imageGalleryFolder + image.uuid + '/' + imageGalleryFileName;
        <swiper-slide class="custom-elevation-z8">
          <img [src]="url" (click)="openImage(image.uuid)" class="gallery-thumbnail" />
      </swiper-slide>
    }
  </swiper-container>
</div>

@if (selectedImage()) {
<div class="lightbox" (click)="closeImageGallery()">
  <div class="lightbox-content gallery-mode" (click)="$event.stopPropagation()">

    <mat-chip-listbox [multiple]="true" (change)="updateFilter($event)">
      <mat-chip-option [value]="'all'" [selected]="activeTags().includes('all')">
        Alle Bilder
      </mat-chip-option>
      @for(tag of uniqueTags(); track $index) {
        <mat-chip-option [value]="tag" [selected]="activeTags().includes(tag)">
        {{ tag }}
        </mat-chip-option>
        }
    </mat-chip-listbox>

    <swiper-container class="lightbox-swiper" [navigation]="true" slidesPerView="1" [spaceBetween]="20"
      [pagination]="{ clickable: true }" (swiperslidechange)="onSlideChange($event)">
      @for (image of filteredImages(); track $index) {
        @if(image.showInGallery) {
          @let url = imageGalleryFolder + image.uuid + '/' + imageGalleryFileName;
          <swiper-slide>
            <img [src]="url" class="lightbox-img" />
          </swiper-slide>
        }
      }
    </swiper-container>
  </div>
</div>
}

@if (openEidtGallery) {
<div class="lightbox admin-theme" (click)="closeImage($event)">
  <div class="lightbox-content admin-mode">
    <app-edit-image-gallery 
      [elemId]="configId"
      (onClose)="openEidtGallery = false">
    </app-edit-image-gallery>
  </div>
</div>
}